import { Helmet } from "react-helmet";

import NursingImage from "../assets/images/Nursing.svg";

const Nursing = () => {
  return (
    <main>
      <Helmet>
        <title>Nursing | Provido</title>
        <meta property="og:title" content="Nursing | Provido" />
        <meta
          name="description"
          content="We can help with any health needs, such as wound care and medication management."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/nursing"
        />
        <meta name="twitter:title" content="Nursing | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mx-12 grid grid-cols-1 gap-8 sm:grid-cols-3 lg:gap-24">
          <div className="order-2 col-span-1 flex items-center lg:order-1 lg:-my-20">
            <img
              src={NursingImage}
              className="-mt-6 max-h-112 w-full pb-6"
              alt="Illustration: a woman in nurse scrubs with a man in a wheelchair."
            />
          </div>
          <div className="order-1 col-span-2 flex flex-col items-center pb-12 sm:order-2 sm:gap-8">
            <div className="pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
              Nursing
            </div>
            <p>
              When health needs are part of your daily life, quality nursing
              supports can make a world of difference. Our qualified Nurses
              provide safe, respectful and skilled care that’s tailored to your
              unique needs, both in the comfort of your own home or out in the
              community.
              <br />
              <br />
              We work closely with participants, families and support teams to
              deliver individualised clinical care that helps you live safely,
              independently and with dignity.
            </p>
          </div>
        </div>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <h2 className="pb-12 text-center font-display text-4xl text-purple">
          How We Can Help You
        </h2>
        <div className="mx-auto grid w-fit grid-cols-1 gap-12 md:grid-cols-2">
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Wound Care and Pressure Injury Management
            </h3>
            <ul className="text-list">
              <li>Dressing changes</li>
              <li>Wound monitoring and documentation</li>
              <li>Chronic wound care</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Medication Management
            </h3>
            <ul className="text-list">
              <li>Medication administration (oral, injectable or PEG)</li>
              <li>Monitoring and managing side effects</li>
              <li>Supporting medication routines</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Continence and Catheter Care
            </h3>
            <ul className="text-list">
              <li>Catheter changes and maintenance</li>
              <li>Bowel and bladder health support</li>
              <li>Stoma care</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              PEG Feeding and Enteral Nutrition
            </h3>
            <ul className="text-list">
              <li>Feeding tube support</li>
              <li>Formula preparation and feeding</li>
              <li>Monitoring nutritional intake</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Diabetes Management
            </h3>
            <ul className="text-list">
              <li>Blood glucose monitoring</li>
              <li>Insulin administration</li>
              <li>Diabetes education and support</li>
            </ul>
          </div>
          <div>
            <h3 className="pb-1 font-display text-xl text-blue">
              Health Assessments and Clinical Reporting
            </h3>
            <ul className="text-list">
              <li>Monitoring vital signs and symptoms</li>
              <li>Liaising with GPs and allied health</li>
              <li>Documentation for NDIS reviews or care plans</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-4xl text-darkblue">
            Who We Support
          </h2>
          <p>
            Our nursing supports are available to NDIS participants with{" "}
            <i>disability-related health conditions</i> that require clinical
            care. This includes people living with:
          </p>
          <ul className="text-list">
            <li>Complex physical disabilities</li>
            <li>Chronic illnesses</li>
            <li>Acquired injuries</li>
            <li>Neurological conditions</li>
            <li>Intellectual and developmental disabilities</li>
          </ul>
          <p>
            We can provide short-term or ongoing care, depending on your NDIS
            plan and health needs. Feel free to get in touch today and find out
            how our nurses can help you.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Nursing;
